/* 


@PRAKT


   _____________________________________________________________

   |
   | INDEX
   |
   _____________________________________________________________
*/

import GLOBALS from './globals';
// import * as responsive from './utils/responsive';
import Embeded from './classes/Embeded';
import Instances from './classes/Instances';
import CollectionBanner from './classes/CollectionBanner';
import ProductRecommendations from './classes/ProductRecommendation';
import FormBirthdate from './classes/FormBirthdate';
import ContactForm from './classes/ContactForm';
import CustomForms from './classes/CustomForms';
import HCCSlideshow from './classes/HCCSlideshow';
import CustomerLocalization from './classes/CustomerLocalization';
import ModalInfo from './classes/ModalInfo';
import CookieConsent from './classes/CookieConsent';
// import perf from './perf';

/* ______________________________________________________________

   |
   | PROJECT
   |
   ______________________________________________________________
*/

/*::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::
::
:: BASIC RESPONSIVE
::
::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::*/

// responsive.cssSetTouchDevices( 'html', 'touch', 'no_touch' );

/*::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::
::
:: INTERFACE
::
::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::*/

const embeded = new Embeded();
const instances = new Instances();
const collectionbanner = new CollectionBanner();
const productrecommendations = new ProductRecommendations();
const formbirthdate = new FormBirthdate();
const contactform = new ContactForm();
const hccslideshow = new HCCSlideshow();
const customerlocalization = new CustomerLocalization();
const modalinfo = new ModalInfo();
const cookieconsent = new CookieConsent();

/*::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::
::
:: DOCUMENT READY
::
::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::*/

document.addEventListener("DOMContentLoaded", (e) => { 
   const customforms = new CustomForms();
});

/*::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::
::
:: WINDOW ON LOAD
::
::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::*/

// window.addEventListener('load', () => {
// });